import { render, staticRenderFns } from "./ForgotPasswordErrorMessage.vue?vue&type=template&id=54170037"
import script from "./ForgotPasswordErrorMessage.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordErrorMessage.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordErrorMessage.vue?vue&type=style&index=0&id=54170037&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports